import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "ph-form-path" }
const _hoisted_2 = { class: "ph-path-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "Prehang", -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", null, "Machine Only", -1)
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", null, "Jambs/Stops", -1)
const _hoisted_9 = { class: "ph-path-description" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }

import { onMounted, ref, watch, PropType } from 'vue'
    import { useAppStore } from '@/stores/app'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'PreHangPathSelection',
  props: {
        pathSelection: { type: String, required: true },
        availableForms: { type: Array as PropType<String[]>, required: true }
    },
  emits: ['update:pathSelection', 'confirmPath'],
  setup(__props, { emit: emits }) {

const props = __props

    
    const appStore = useAppStore()
    const selectedPath = ref<string>("")

    

    watch(selectedPath, (current, old) => {
        if(current !== props.pathSelection) {
            emits("update:pathSelection", current)
        }
    })

    onMounted(() => {
        if(props.pathSelection) {
            selectedPath.value = props.pathSelection
        }
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (props.availableForms.includes('prehang'))
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            class: _normalizeClass(["ph-path-btn", { 'selected': selectedPath.value == 'prehang' }]),
            onClick: _cache[0] || (_cache[0] = () => {selectedPath.value = 'prehang'}),
            onDblclick: _cache[1] || (_cache[1] = () => {emits('confirmPath','prehang')})
          }, [
            _createElementVNode("img", {
              src: _unref(appStore).publicPath + '/test/prehang_v2.png',
              alt: "Prehang Icon",
              title: "Prepare prehang installation"
            }, null, 8, _hoisted_3),
            _hoisted_4
          ], 34))
        : _createCommentVNode("", true),
      (props.availableForms.includes('machine'))
        ? (_openBlock(), _createElementBlock("li", {
            key: 1,
            class: _normalizeClass(["ph-path-btn", { 'selected': selectedPath.value == 'machine' }]),
            onClick: _cache[2] || (_cache[2] = () => {selectedPath.value = 'machine'}),
            onDblclick: _cache[3] || (_cache[3] = () => {emits('confirmPath','machine')})
          }, [
            _createElementVNode("img", {
              src: _unref(appStore).publicPath + '/test/machine_v2.png',
              alt: "Door Icon",
              title: "Prepare Machine only installation"
            }, null, 8, _hoisted_5),
            _hoisted_6
          ], 34))
        : _createCommentVNode("", true),
      (props.availableForms.includes('jambs'))
        ? (_openBlock(), _createElementBlock("li", {
            key: 2,
            class: _normalizeClass(["ph-path-btn", { 'selected': selectedPath.value == 'jambs' }]),
            onClick: _cache[4] || (_cache[4] = () => {selectedPath.value = 'jambs'}),
            onDblclick: _cache[5] || (_cache[5] = () => {emits('confirmPath','jambs')})
          }, [
            _createElementVNode("img", {
              src: _unref(appStore).publicPath + '/test/jambs_v2.png',
              alt: "Jambs Icon",
              title: "Add additional jambs and stops"
            }, null, 8, _hoisted_7),
            _hoisted_8
          ], 34))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (selectedPath.value == 'prehang')
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Build Single or Double Door units. "))
        : (selectedPath.value == 'machine')
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Prepare your door for installation into an existing frame, pocket door, or groove for barn door guide. "))
          : (selectedPath.value == 'jambs')
            ? (_openBlock(), _createElementBlock("p", _hoisted_12, " Add additional jambs and/or stops. "))
            : _createCommentVNode("", true)
    ])
  ]))
}
}

})